class BlogSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        const swiperEl = this.querySelector('.blog-slider');
        if (!swiperEl) return;

        // Initialize Swiper
        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1.1,
            spaceBetween: 12,
            breakpoints: {
                540: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.2, spaceBetween: 24 },
                992: { slidesPerView: 3 }
            }
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }
    }
}

customElements.define("blog-slider", BlogSlider);